// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"8bb9bba6","132":"a1d21a14","243":"4f3f076a","438":"ef633899","488":"0aacd843","508":"bf455c90","691":"14b0fe74","861":"817f0e4e","942":"319e34b6"}[chunkId] + ".chunk.js";
};